/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Rider } from '../../models/rider';

export interface SynchronizeRiders$Params {
  raceGuid: string;
}

export function synchronizeRiders(http: HttpClient, rootUrl: string, params: SynchronizeRiders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Rider>>> {
  const rb = new RequestBuilder(rootUrl, synchronizeRiders.PATH, 'get');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Rider>>;
    })
  );
}

synchronizeRiders.PATH = '/races/{raceGuid}/syncriders';
